import { RadioGroup } from '@headlessui/react'
import { CheckIcon } from '@heroicons/react/solid'
import { classNames } from '@progress/kendo-react-common'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { Popup } from '@progress/kendo-react-popup'
import Translation from 'components/Translation'
import { useTenantContext } from 'context/TenantContext'
import getConfig from 'next/config'
import { useEffect, useRef, useState } from 'react'
import { getTranslation } from 'utils/language-helper'
import { CodeOption } from '../Service/BookingSettings'
import { ModalDataAttributes } from '../types'
import { CopyIcon, InfoIcon, TickIcon } from 'utils/custom-icons'
import { useAuth } from 'context/AuthContext'

function MembershipBookingPage({
    attributes,
    setAttributes,
    translations,
    onCancel,
    onPrevious,
    onSubmit,
}: {
    attributes?: ModalDataAttributes
    setAttributes(r: ModalDataAttributes): void
    translations: Record<string, string>
    onCancel(): void
    onPrevious(): void
    onSubmit(): void
}) {
    const { BOOKING_HOST, NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig
    const { tenant_subdomains } = useTenantContext()
    const { GlobalDialog } = useAuth()
    const api_error =
        attributes && (attributes.api_error as Record<string, string>)
    const learn_anchor = useRef<HTMLButtonElement | null>(null)
    const [show_learn_info, setShowLearnInfo] = useState(false)
    const [sharing_code_options, setSharingCodeOptions] = useState<CodeOption[]>([])
    const [code_option, setCodeOption] = useState<CodeOption>(sharing_code_options[0])
    const privacy_options = [
        {
            name: 'privacy_option_public',
            description: 'privacy_option_public_desc',
            value: true,
        },
        {
            name: 'privacy_option_private',
            description: 'privacy_option_private_desc',
            value: false,
        },
    ]

    useEffect(() => {
        let subdomain = undefined
        if (tenant_subdomains && tenant_subdomains.length) {
            if (tenant_subdomains[0]?.subdomain) {
                subdomain = tenant_subdomains[0].subdomain
            }
        }
        const updated_options = [
            {
                name: getTranslation('embed_booking_page', translations),
                value: `<iframe src="https://${subdomain ? subdomain + '.' : ''}${BOOKING_HOST
                    }/book/memberships/?&l=${attributes?.primary_location_id
                    }&m=${attributes?.id}${attributes?.is_public ? '' : '&isPrivate=true'
                    }" title="Book an Appointment using AOT!" frameborder="no" id="myIframe" scrolling="no" color="" render="bg-w-image" style="width:100%;"></iframe><script src="https://${NEXT_PUBLIC_STATIC_DOMAIN}/js/aot-embed.js" type="text/javascript"></script>`,
                icon: 'feather-copy',
            },
            {
                name: getTranslation('standalone_booking_page', translations),
                value: `https://${subdomain ? subdomain + '.' : ''}${BOOKING_HOST
                    }/book/memberships/?&l=${attributes?.primary_location_id
                    }&m=${attributes?.id}${attributes?.is_public ? '' : '&isPrivate=true'
                    }`,
                icon: 'feather-arrow-up-right',
            },
        ]
        setSharingCodeOptions(updated_options)
        setCodeOption(updated_options[0])

    }, [tenant_subdomains])

    return (
        <>
            {code_option &&
                <div className="relative flex flex-col gap-8">
                    <div>
                        <div className="membership-title mb-5">
                            <Translation
                            render_as="h3"
                                content_key="privacy_title_1"
                                translations={translations}
                            />
                            <Translation
                                render_as="p"
                                
                                content_key="privacy_body"
                                translations={translations}
                            />
                        </div>
                        <div className="mt-3">
                            <RadioGroup
                                value={attributes?.is_public as boolean}
                                onChange={(is_public: boolean) => {
                                    setAttributes({
                                        ...attributes,
                                        is_public,
                                    })
                                }}
                            >
                                <RadioGroup.Label className="sr-only">
                                    <Translation
                                        content_key="privacy"
                                        translations={translations}
                                    />
                                </RadioGroup.Label>

                                <div className="flex gap-6">
                                    {privacy_options.map((op) => {
                                        return (
                                            <RadioGroup.Option
                                                key={op.name}
                                                value={op.value}
                                                className={({
                                                    active,
                                                    checked,
                                                }) => {
                                                    return classNames(
                                                        active
                                                            ? 'ring-2 ring-offset-2 ring-offset-sky-300 ring-primary-light ring-opacity-60'
                                                            : '',
                                                        checked
                                                            ? 'text-primary'
                                                            : 'bg-red',
                                                        'relative rounded-lg shadow-md px-5 py-4 cursor-pointer flex focus:outline-none'
                                                    )
                                                }}
                                            >
                                                {({ active, checked }) => {
                                                    return (
                                                        <>
                                                            <div className="flex flex-row gap-2 items-center">
                                                                <div className="">
                                                                    {checked && (
                                                                        <TickIcon />
                                                                    )}
                                                                </div>
                                                                        <RadioGroup.Label
                                                                            as="p"
                                                                            className={`font-medium text-sm ${checked
                                                                                ? 'text-primary'
                                                                                : 'text-gray-400'
                                                                                }`}
                                                                        >
                                                                            {
                                                                                <Translation
                                                                                    content_key={
                                                                                        op.name
                                                                                    }
                                                                                />
                                                                            }
                                                                        </RadioGroup.Label>
                                                                        <span
                                                                        title={getTranslation(
                                                                            op.description,
                                                                            translations
                                                                        )}
                                                                    >
                                                                        <InfoIcon />
                                                                    </span>
                                                                        {/* <RadioGroup.Description
                                                                            as="span"
                                                                            className={`inline ${checked
                                                                                ? 'text-primary'
                                                                                : 'text-gray-400'
                                                                                }`}
                                                                        >
                                                                            <span>
                                                                                {
                                                                                    <Translation
                                                                                        content_key={
                                                                                            op.description
                                                                                        }
                                                                                    />
                                                                                }
                                                                            </span>
                                                                        </RadioGroup.Description> */}
                                                            </div>
                                                        </>
                                                    )
                                                }}
                                            </RadioGroup.Option>
                                        )
                                    })}
                                </div>
                            </RadioGroup>
                        </div>
                    </div>
                    <div className="text-primary text-lg font-medium font-display">
                        <Translation
                            content_key="membership_sharing_title"
                            translations={translations}
                        />
                        <Translation
                            render_as="div"
                            className="text-base text-gray-900 mt-2"
                            content_key="membership_sharing_body"
                            translations={translations}
                        />
                    </div>
                    <div className="flex flex-col gap-3">
                        <fieldset className="w-1/4">
                            <Translation
                                render_as="label"
                                className="block text-sm"
                                htmlFor="sharing_method"
                                content_key="sharing_method"
                            />
                            <DropDownList
                                id="sharing_method"
                                className="bg-white px-2 py-1 mt-1 block w-full shadow-sm border border-gray-300 rounded-md text-base"
                                iconClassName="feather-chevron-down"
                                data={sharing_code_options}
                                textField="name"
                                dataItemKey="value"
                                value={code_option}
                                popupSettings={{ height: 'h-full', className:"z-[102]" }}
                                onChange={(e) => {
                                    setCodeOption(e.target.value)
                                }}
                                disabled={!attributes?.id}
                            />
                        </fieldset>
                        <fieldset className="">
                            <div className="flex flex-row items-center gap-2">
                                <Translation
                                    render_as="label"
                                    className="text-sm"
                                    htmlFor="code_to_add"
                                    content_key="code_to_add"
                                />
                                <span
                            className=""
                            title={getTranslation(
                                "code_to_add_desc",
                                translations
                            )}
                        >
                            <InfoIcon />
                        </span>
                                {/* <span
                                    className="text-primary-light ml-3"
                                    ref={learn_anchor}
                                    onMouseEnter={() => setShowLearnInfo(true)}
                                    onMouseLeave={() => setShowLearnInfo(false)}
                                >
                                    <i className="feather-info mr-1" />
                                    <Translation
                                        render_as="label"
                                        content_key="code_to_add_learn"
                                    />
                                </span> */}
                            </div>
                            <div className="flex flex-row items-center gap-2">
                                <input
                                    type="text"
                                    id="code_to_add"
                                    className="pl-3 pr-6 py-3 mt-1 focus:ring-primary-light focus:border-primary-light block w-full shadow-sm border-gray-300 rounded-md disabled:text-gray-400"
                                    value={attributes?.id ? code_option.value : ''}
                                    onChange={() => { }}
                                    disabled={!attributes?.id}
                                />
                                <span
                        // onClick={() => {
                        //     if (!attributes?.id) {
                        //         return
                        //     }
                        //     if (
                        //         code_option.name ==
                        //         sharing_code_options[0].name
                        //     ) {
                        //         navigator.clipboard.writeText(
                        //             code_option.value
                        //         )
                        //     } else {
                        //         window
                        //             .open(code_option.value, '_blank')
                        //             ?.focus()
                        //     }
                        // }}
                        onClick={() => {
                            if (!attributes?.id) {
                                return
                            }
                            if (
                                code_option?.name ==
                                sharing_code_options[0]?.name
                            ) {
                                navigator.clipboard.writeText(
                                    code_option?.value
                                )
                                GlobalDialog.setAttributes({
                                    message: 'Copied to clipboard.',
                                    className: 'w-96 overflow-hidden',
                                })
                                GlobalDialog.open()
                                setTimeout(() => {
                                    GlobalDialog.close()
                                }, 1200)
                            } else {
                                window.open(
                                    code_option?.value,
                                    '_blank',
                                    'noopener,noreferrer'
                                )
                            }
                        }}
                        title={getTranslation(
                            'Copy',
                            translations
                        )}
                        >
                            <CopyIcon color="#5E9FBD" style={{ cursor: attributes?.id ? 'pointer' : 'not-allowed', width: '20px', height: '20px' }} />
                        </span>
                                {/* <i
                                    className={classNames(
                                        'text-lg bg-white absolute p-2 right-3 top-1',
                                        code_option.icon,
                                        attributes?.id ? 'cursor-pointer text-primary-light' : 'text-gray-400'
                                    )}
                                    onClick={() => {
                                        if (!attributes?.id) {
                                            return
                                        }
                                        if (
                                            code_option.name ==
                                            sharing_code_options[0].name
                                        ) {
                                            navigator.clipboard.writeText(
                                                code_option.value
                                            )
                                        } else {
                                            window
                                                .open(code_option.value, '_blank')
                                                ?.focus()
                                        }
                                    }}
                                /> */}
                            </div>
                        </fieldset>
                    </div>
                    <div className="mt-5 flex justify-end gap-3">
                        <button
                            type="button"
                            className="border border-gray-300 rounded-lg  inline-block btn-gap"
                            onClick={() => {
                                onCancel()
                            }}
                        >
                            <Translation
                                content_key="cancel"
                                translations={translations}
                            />
                        </button>
                        <div className="flex justify-end gap-3">
                            <button
                                type="button"
                                className="border border-gray-300 rounded-lg  inline-block btn-gap"
                                onClick={() => {
                                    onPrevious()
                                }}
                            >
                                <Translation
                                    content_key="previous"
                                    translations={translations}
                                />
                            </button>
                            <button
                                type="button"
                                onClick={() => {
                                    onSubmit()
                                }}
                                className={classNames(
                                    'group relative flex justify-center',
                                    'btn-gap border border-transparent',
                                    'rounded-md text-white',
                                    'focus:outline-none',
                                    attributes?.loading
                                        ? 'bg-primary-light'
                                        : attributes?.api_error
                                            ? 'bg-red-700 hover:bg-primary-dark focus:ring-2 focus:ring-offset-2 focus:ring-primary-light'
                                            : 'bg-primary hover:bg-primary-dark focus:ring-2 focus:ring-offset-2 focus:ring-primary-light'
                                )}
                            >
                                <Translation
                                    content_key="save"
                                    translations={translations}
                                />
                            </button>
                        </div>
                    </div>

                    <Popup
                        anchor={learn_anchor.current}
                        show={show_learn_info}
                        animate={false}
                        popupAlign={{
                            horizontal: 'left',
                            vertical: 'top',
                        }}
                        popupClass={
                            'bg-black text-white shadow-lg rounded-xl w-96 px-5 py-3 mt-2'
                        }
                        className="z-[102]"
                    >
                        <Translation render_as="p" content_key="code_to_add_desc" />
                    </Popup>
                </div>
            }
        </>
    )
}

export default MembershipBookingPage
